import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const HomeDailyLessonChangeIcon = ({ classObject }) => {
    return React.createElement("img", { className: css(styles.icon, classObject), src: "/assets/images/icons/home_daily_lesson_change.svg" });
};
const styles = StyleSheet.create({
    icon: {
        width: 24,
        height: 24,
        display: 'block',
        flexShrink: 0,
    },
});
